import * as React from "react";
import { UitkSpacing } from "uitk-react-spacing";
import { FrequentlyAskedQuestions as SharedUIFAQ } from "@shared-ui/retail-travel-content-frequently-asked-questions";
import { observer, inject } from "mobx-react";
import { FaqProps } from "./typings";
import { FrequentlyAskedQuestionsFlexModuleResult } from "typings/microserviceModels/frequently-asked-questions-flex-module";
import { LazyLoad } from "src/components/utility/LazyLoad/LazyLoad";

type FaqModel = FrequentlyAskedQuestionsFlexModuleResult | null;

const FrequentlyAskedQuestions = (props: FaqProps) => {
  const { context, flexTemplateNode, flexModuleModelStore, uriContext: uriContextStore } = props;

  if (!context || !flexTemplateNode || !flexModuleModelStore || !uriContextStore) {
    return null;
  }

  const model = flexModuleModelStore.getModel(flexTemplateNode.id) as FaqModel;
  const uriContext = uriContextStore.get();

  if (!model || !uriContext) {
    return null;
  }

  const { displayThreshold, limit } = model;

  const inputs = {
    uriContextV1: uriContext,
    // Deprecated
    uriContext: {
      identifiers: { destination: "" },
      attributes: {},
    },
    limit: limit || 12,
  };

  return (
    <UitkSpacing padding={{ block: "three" }}>
      <div>
        <LazyLoad context={context}>
          <SharedUIFAQ inputs={inputs} displayThreshold={displayThreshold} />
        </LazyLoad>
      </div>
    </UitkSpacing>
  );
};

export const FrequentlyAskedQuestionsModule = inject(
  "flexModuleModelStore",
  "uriContext"
)(observer(FrequentlyAskedQuestions));

export default FrequentlyAskedQuestionsModule;
